<template>
  <div
    v-if="isVisible"
    :data-cy="`baseToast-${notificationConfig.type}`"
    :class="['fc-notification-container xy-center p-12 pr-48 left-0 right-0 mr-auto',
             ' ml-auto clickable w-fit-content border-radius-8 pos-absolute z-index-3'
             , notificationConfig.type, notificationConfig.placement, {
               'mt-24': globalStore.getIsMobileView()
             }]">
    <img :src="getStatusIcon">
    <p :class="['notificartion-title ml-12 font-size-18 semi-bold', notificationConfig.type]">
      {{ notificationConfig.text }}
    </p>
    <i
      v-if="shouldShowCrossIcon"
      :class="['cross-icon fa fa-times clickable font-size-14 pos-absolute right-12', notificationConfig.type]"
      @click="globalStore.hideNotification()" />
  </div>
</template>

<script setup lang="ts">
  import { computed, inject } from "vue";
  import { GLOBAL_STORE_INJECTION_KEY } from "@/store/keys";

  const globalStore = inject(GLOBAL_STORE_INJECTION_KEY)!;

  import CheckIcon from "@/assets/check-icon.svg";
  import CrossIcon from "@/assets/cross-icon.svg";
  import { NotificationStatus } from "@/lib/utils";

  const isVisible = computed(() => globalStore.state.isNotificationVisible);
  const notificationConfig = computed(() => globalStore.getNotificationConfig());
  const shouldShowCrossIcon = computed(() => notificationConfig.value.closeable);

  const getStatusIcon = computed(() => notificationConfig.value.statusIcon || (
    notificationConfig.value.type === NotificationStatus.SUCCESS
      ? CheckIcon
      : notificationConfig.value.type === NotificationStatus.ERROR
        ? CrossIcon
        : null
  )
  );
</script>
<style lang="scss">
.fc-notification-container {
  max-width: 700px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);

  &.success {
    background-color: $brand-tertiary-light;
  }

  &.error {
    background-color: $system-error-normal;
  }

  &.warning {
    background-color: $brand-primary-light;
  }

  &.bottom {
    bottom: 24px;
  }

  &.top {
    top: 24px;
  }

  .notificartion-title,
  .cross-icon {
    &.success {
      color: $system-success-dark;
    }

    &.error {
      color: $system-error-dark;
    }

    &.warning {
      color: $brand-primary-normal;
    }
  }
}

@media (max-width: 643px) {
  .fc-notification-container {
    &.bottom {
      bottom: 0;
    }

    &.top {
      top: 0;
    }
  }
}
</style>
